import { cva } from 'class-variance-authority';
export const cardStyling = cva('bg-neutral-50', {
    variants: {
        padding: {
            none: 'p-6',
            sm: 'p-6',
            md: 'p-8',
            lg: 'p-10',
        },
        rounding: {
            none: 'rounded-none',
            sm: 'rounded-md',
            md: 'rounded-3xl',
            lg: 'rounded-3xl',
            xl: 'rounded-3xl',
        },
    },
    defaultVariants: {
        padding: 'md',
        rounding: 'md',
    },
});
export const cardHeaderStyling = cva('', {
    variants: {
        padding: {
            none: 'pb-0',
            sm: 'pb-6',
            md: 'pb-8',
            lg: 'pb-10',
        },
    },
    defaultVariants: {
        padding: 'md',
    },
});
export const cardContentStyling = cva('bg-white rounded-2xl', {
    variants: {
        padding: {
            none: 'p-0',
            sm: 'p-6',
            md: 'p-8',
            lg: 'p-10',
        },
    },
    defaultVariants: {
        padding: 'md',
    },
});
